'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * @fileOverview Cross
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactUtils = require('../util/ReactUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Cell() {
  return null;
}

Cell.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
Cell.displayName = 'Cell';

exports.default = Cell;


//////////////////
// WEBPACK FOOTER
// ./~/recharts/lib/component/Cell.js
// module id = 73
// module chunks = 0